import Vue from 'vue';
import Vuex from 'vuex';

// Modules
import ecommerceStoreModule from '@/views/apps/e-commerce/eCommerceStoreModule';
import app from './app';
import appConfig from './app-config';
import verticalMenu from './vertical-menu';
import module from './module';
import patient from './patient';
import doctors from './doctors';
import pharmacy from './app/pharmacy';
import auth from './auth';
import verify from './verify';
import departments from './Utilities/departments'; //
import jobTitles from './Utilities/jobTitles';
import DiseaseCategory from './Utilities/DiseaseCategory';
import DiseaseSubcategory from './Utilities/DiseaseSubcategory';
import DiseaseItem from './Utilities/DiseaseItem';
import Prognosis from './Utilities/Prognosis';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    module,
    verify,
    jobTitles,
    departments,
    auth,
    patient,
    doctors,
    DiseaseCategory,
    DiseaseSubcategory,
    DiseaseItem,
    Prognosis,
    'app-ecommerce': ecommerceStoreModule,
    pharmacy,
  },
  strict: process.env.DEV,
});
